import React from 'react'

const HelpIcon = ({url}) => {

    return <a className="grey-text valign-wrapper" title="Voir le manuel d'explication" href={url} target="_blank">
        <i className="material-icons">help</i>
    </a>
}

export default HelpIcon